import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import * as Sentry from '@sentry/angular'
import { Integrations } from '@sentry/tracing'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

/* google ad manager */
declare global {
  interface Window {
    googletag: any
  }
}

// encode된 url로 접근하는 경우 decode 후 redirection
if (window.location.href.includes('%3F')) {
  window.location.href = decodeURIComponent(window.location.href)
}

const ignoreErrorList = [
  `Non-Error`,
  `AbortError:`,
  `Can't find variable: memno`,
  `Can't find variable: shakehot`,
  `Uncaught (in promise): ChunkLoadError`,
  `Uncaught (in promise): Error: event capacitorDidRegisterForRemoteNotifications`,
  `Uncaught (in promise): AbortError`,
]

const sentryOptions = (dsn: string) => {
  return {
    release: (environment.production ? 'types-prod' : 'types-dev') + '@0.0.1',
    dsn,
    environment: environment.production ? 'production' : 'develop',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      new Integrations.BrowserTracing(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.production ? 0.2 : 1.0,
    beforeSend(event, hint) {
      // ignore those kind of errors
      if (
        event.exception !== undefined &&
        Array.isArray(event.exception.values) &&
        event.exception.values[0].value !== undefined
      ) {
        const exception = event.exception.values[0].value
        const ignoreError: string[] = ignoreErrorList.filter(
          (item) => typeof exception === 'string' && exception.startsWith(item)
        )
        if (Array.isArray(ignoreError) && ignoreError.length > 0) {
          return null
        }
      }

      const originalExceptionKey = 'message'
      if (hint !== undefined && hint.originalException) {
        const originalException = (hint.originalException as any)[originalExceptionKey]
        const ignoreError: string[] = ignoreErrorList.filter(
          (item) => typeof originalException === 'string' && originalException.startsWith(item)
        )
        if (Array.isArray(ignoreError) && ignoreError.length > 0) {
          return null
        }
      }

      return event
    },
  }
}

const sentryInit = () => {
  const options = sentryOptions('https://ca7efcd3f69a4b34bc4657963b373d5d@o321314.ingest.sentry.io/6035127')
  Sentry.init(options)
}

if (environment.production) {
  enableProdMode()
  sentryInit()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((success) => {})
  .catch((err) => console.error(err))
